var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70175 14.7018L12.7018 9.70176C12.8947 9.52632 13 9.2807 13 9C13 8.45614 12.5439 8 12 8C11.7193 8 11.4737 8.10526 11.2982 8.29825L6.29825 13.2982C6.10526 13.4737 6 13.7193 6 14C6 14.5439 6.45614 15 7 15C7.2807 15 7.52632 14.8947 7.70175 14.7018ZM17.7018 13.2982L12.7018 8.29825C12.5263 8.10526 12.2807 8 12 8C11.4561 8 11 8.45614 11 9C11 9.2807 11.1053 9.52632 11.2982 9.70176L16.2982 14.7018C16.4737 14.8947 16.7193 15 17 15C17.5439 15 18 14.5439 18 14C18 13.7193 17.8947 13.4737 17.7018 13.2982Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up.10e2d497.svg";
export { ForwardRef as ReactComponent };